import { render, staticRenderFns } from "./organizationUnits.vue?vue&type=template&id=5f5cf329"
import script from "./organizationUnits.vue?vue&type=script&lang=js"
export * from "./organizationUnits.vue?vue&type=script&lang=js"
import style0 from "./organizationUnits.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports